import React from "react";
import { Stack } from "@mui/material";
import { ImageOff } from "lucide-react";

// Renders an item image, falling back to a placeholder icon when the URL is
// missing or fails to load (instead of the browser's broken-image glyph).
const ItemImage = ({
  src,
  alt,
  style,
  className,
  iconSize = 36,
  fallbackStyle,
}) => {
  const [failedSrc, setFailedSrc] = React.useState(null);

  if (!src || failedSrc === src) {
    const computedFallbackStyle = {
      ...style,
      width: (style && (style.width || style.maxWidth)) || "100%",
      height: (style && (style.height || style.maxHeight)) || "100%",
      ...fallbackStyle,
    };
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        style={computedFallbackStyle}
        sx={{ color: "#9e9e9e" }}
      >
        <ImageOff size={iconSize} />
      </Stack>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      className={className}
      onError={() => setFailedSrc(src)}
    />
  );
};

export default ItemImage;
